
// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const AdminPage = () => {
//   const [pendingUsers, setPendingUsers] = useState([]);
//   const [pendingEvents, setPendingEvents] = useState([]);

//   const token = localStorage.getItem("token");

//   useEffect(() => {
//     fetchPendingUsers();
//     fetchPendingEvents();
//   }, []);

//   const fetchPendingUsers = async () => {
//     try {
//       const response = await axios.get("https://localhost:7136/api/admin/accounts/pending", {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       setPendingUsers(response.data);
//     } catch (error) {
//       console.error("Error fetching pending users:", error);
//     }
//   };

//   const fetchPendingEvents = async () => {
//     try {
//       const response = await axios.get("https://localhost:7136/api/event/pending", {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       setPendingEvents(response.data);
//     } catch (error) {
//       console.error("Error fetching pending events:", error);
//     }
//   };

//   const handleUserApproval = async (userId, approve) => {
//     try {
//       if (approve) {
//         await axios.post(`https://localhost:7136/api/admin/account/${userId}/accept`, null, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//       } else {
//         await axios.delete(`https://localhost:7136/api/admin/account/${userId}/reject`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//       }
//       fetchPendingUsers();
//     } catch (error) {
//       console.error("Error updating user approval:", error);
//     }
//   };

//   const handleEventApproval = async (eventId, approve) => {
//     try {
//       if (approve) {
//         await axios.post(`https://localhost:7136/api/admin/events/${eventId}/approve`, null, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//       } else {
//         await axios.delete(`https://localhost:7136/api/admin/events/${eventId}/reject`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//       }
//       fetchPendingEvents();
//     } catch (error) {
//       console.error("Error updating event approval:", error);
//     }
//   };

//   return (
//     <div
//       className="min-h-screen bg-cover bg-center p-6"
//       style={{ backgroundImage: "url('/images/photo8.jpeg')" }} // <-- background image
//     >
//       <div className="bg-white bg-opacity-80 p-6 max-w-4xl mx-auto rounded-xl shadow-lg">
//         <h1 className="text-3xl font-bold mb-6">Admin Panel</h1>

//         {/* Pending Users Section */}
//         <section className="mb-10">
//           <h2 className="text-2xl font-semibold mb-4">Pending Users</h2>
//           {pendingUsers.length === 0 ? (
//             <p className="text-gray-700">No pending users.</p>
//           ) : (
//             <ul className="space-y-2">
//               {pendingUsers.map((user) => (
//                 <li
//                   key={user.userId}
//                   className="bg-white shadow p-4 rounded-lg flex justify-between items-center"
//                 >
//                   <div>
//                     <p className="font-semibold">{user.fullName}</p>
//                     <p className="text-sm text-gray-600">{user.email}</p>
//                   </div>
//                   <div className="space-x-2">
//                     <button
//                       onClick={() => handleUserApproval(user.userId, true)}
//                       className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded"
//                     >
//                       Approve
//                     </button>
//                     <button
//                       onClick={() => handleUserApproval(user.userId, false)}
//                       className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
//                     >
//                       Reject
//                     </button>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </section>

//         {/* Pending Events Section */}
//         <section>
//           <h2 className="text-2xl font-semibold mb-4">Pending Events</h2>
//           {pendingEvents.length === 0 ? (
//             <p className="text-gray-700">No pending events.</p>
//           ) : (
//             <ul className="space-y-2">
//               {pendingEvents.map((event) => (
//                 <li
//                   key={event.eventId}
//                   className="bg-white shadow p-4 rounded-lg space-y-2"
//                 >
//                   <div>
//                     <h3 className="text-lg font-bold">{event.title}</h3>
//                     <p className="text-sm text-gray-700">
//                       <span className="font-semibold">Organizer:</span>{" "}
//                       {event.organizerName}
//                     </p>
//                     <p className="text-sm text-gray-700">
//                       <span className="font-semibold">Venue:</span> {event.venue}
//                     </p>
//                     <p className="text-sm text-gray-700">
//                       <span className="font-semibold">Price:</span> ${event.ticketPrice}
//                     </p>
//                     <p className="text-sm text-gray-700">
//                       <span className="font-semibold">Date:</span>{" "}
//                       {new Date(event.eventDatetime).toLocaleString()}
//                     </p>
//                   </div>
//                   <div className="space-x-2">
//                     <button
//                       onClick={() => handleEventApproval(event.eventId, true)}
//                       className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded"
//                     >
//                       Approve
//                     </button>
//                     <button
//                       onClick={() => handleEventApproval(event.eventId, false)}
//                       className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
//                     >
//                       Reject
//                     </button>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </section>
//       </div>
//     </div>
//   );
// };

// export default AdminPage;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AdminPage = () => {
  const [pendingUsers, setPendingUsers] = useState([]);
  const [pendingEvents, setPendingEvents] = useState([]);
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchPendingUsers();
    fetchPendingEvents();
  }, []);

  const fetchPendingUsers = async () => {
    try {
      const response = await axios.get("https://localhost:7136/api/admin/accounts/pending", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPendingUsers(response.data);
    } catch (error) {
      console.error("Error fetching pending users:", error);
    }
  };

  const fetchPendingEvents = async () => {
    try {
      const response = await axios.get("https://localhost:7136/api/event/pending", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPendingEvents(response.data);
    } catch (error) {
      console.error("Error fetching pending events:", error);
    }
  };

  const handleUserApproval = async (userId, approve) => {
    try {
      if (approve) {
        await axios.post(`https://localhost:7136/api/admin/account/${userId}/approve`, null, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        await axios.delete(`https://localhost:7136/api/admin/account/${userId}/reject`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
      fetchPendingUsers();
    } catch (error) {
      console.error("Error updating user approval:", error);
    }
  };

  const handleEventApproval = async (eventId, approve) => {
    try {
      if (approve) {
        await axios.post(`https://localhost:7136/api/admin/events/${eventId}/approve`, null, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        await axios.delete(`https://localhost:7136/api/admin/events/${eventId}/reject`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
      fetchPendingEvents();
    } catch (error) {
      console.error("Error updating event approval:", error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    navigate("/home");
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center p-6"
      style={{ backgroundImage: "url('./images/photo8.jpeg')" }}
    >
      <div className="bg-white bg-opacity-80 p-6 max-w-4xl mx-auto rounded-xl shadow-lg">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold">Admin Panel</h1>
          <button
            onClick={handleLogout}
            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition"
          >
            تسجيل الخروج
          </button>
        </div>

        {/* Pending Users Section */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-4">Pending Users</h2>
          {pendingUsers.length === 0 ? (
            <p className="text-gray-700">No pending users.</p>
          ) : (
            <ul className="space-y-2">
              {pendingUsers.map((user) => (
                <li
                  key={user.userId}
                  className="bg-white shadow p-4 rounded-lg flex justify-between items-center"
                >
                  <div>
                    <p className="font-semibold">{user.fullName}</p>
                    <p className="text-sm text-gray-600">{user.email}</p>
                  </div>
                  <div className="space-x-2">
                    <button
                      onClick={() => handleUserApproval(user.userId, true)}
                      className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded"
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => handleUserApproval(user.userId, false)}
                      className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                    >
                      Reject
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </section>

        {/* Pending Events Section */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">Pending Events</h2>
          {pendingEvents.length === 0 ? (
            <p className="text-gray-700">No pending events.</p>
          ) : (
            <ul className="space-y-2">
              {pendingEvents.map((event) => (
                <li
                  key={event.eventId}
                  className="bg-white shadow p-4 rounded-lg space-y-2"
                >
                  <div>
                    <h3 className="text-lg font-bold">{event.title}</h3>
                    <p className="text-sm text-gray-700">
                      <span className="font-semibold">Organizer:</span> {event.organizerName}
                    </p>
                    <p className="text-sm text-gray-700">
                      <span className="font-semibold">Venue:</span> {event.venue}
                    </p>
                    <p className="text-sm text-gray-700">
                      <span className="font-semibold">Price:</span> ${event.ticketPrice}
                    </p>
                    <p className="text-sm text-gray-700">
                      <span className="font-semibold">TotalTickets:</span> ${event.totalTickets}
                    </p>
                    <p className="text-sm text-gray-700">
                      <span className="font-semibold">Date:</span>{" "}
                      {new Date(event.eventDatetime).toLocaleString()}
                    </p>
                  </div>
                  <div className="space-x-2">
                    <button
                      onClick={() => handleEventApproval(event.eventId, true)}
                      className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded"
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => handleEventApproval(event.eventId, false)}
                      className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                    >
                      Reject
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </div>
  );
};

export default AdminPage;

